/**
 * @file Entry point for authentication pages (Login, Register).
 */

import "./loginForm.js";
import "./registerForm.js";
import "./resetPasswordForm.js";
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;
